import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { Outlet } from 'react-router-dom';

import PrintTopbar from './PrintTopbar';

const useStyles = makeStyles()((theme) => ({
  root: {
    paddingTop: 56,
    height: '100%',
    [theme.breakpoints.up('sm')]: {
      paddingTop: 64,
    },
    [theme.breakpoints.up('xs')]: {
      paddingTop: 56,
    },
    '@media print': {
      paddingTop: '0px',
    },
  },
  content: {
    height: '100%',
  },
}));

function PrintLayout({ children }) {
  const { classes } = useStyles();

  return (
    <div className={classes.root}>
      <PrintTopbar />
      <main className={classes.content}>
        <Outlet />
      </main>
    </div>
  );
}

export default PrintLayout;
